<script lang="ts">
    import { Progress } from "sveltestrap";
    import { Col, Row } from "sveltestrap";
    import { ticketData } from "../../../Data/Miscellaneous/SupportTicket";
    import { Loss, Profit } from "../../../utils/Constant/Constant";
    import Card from "../../Core/Card.svelte";
</script>
  
<Row>
  {#each ticketData as elem}
    <Col xl="4" sm="6">
      <Card cardProps="ecommerce-widget pro-gress" cardBodyprops="support-ticket-font">
        <div
          slot="contentbody"
          class="support-ticket d-flex flex-column gap-3"
        >
          <Row>
            <Col xs="5">
              <h6>{elem.title}</h6>
              <h3 class="total-num counter">{elem.num}</h3>
            </Col>
            <Col xs="7">
              <div class="text-md-end">
                <ul>
                  <li>{Profit}
                    <span class="product-stts txt-success ms-2">{elem.num2}
                      <i class="icon-angle-up f-12 ms-1" />
                    </span>
                  </li>
                  <li>{Loss}
                    <span class="product-stts txt-danger ms-2">{elem.num3}
                      <i class="icon-angle-down f-12 ms-1" />
                    </span>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
          <Progress color={elem.class} value={70} class="support-kit" />
        </div>
      </Card>
    </Col>
  {/each}
</Row>
  